<template>
  <div class="addNewItems">
    <v-row>
      <v-col cols="4">
        <b-btn @click="itemHinzufuegen()" fab small>
          <v-icon>
            mdi-plus
          </v-icon>
        </b-btn>
      </v-col>
      <v-col cols="8" v-if="zeigeItemHinzufuegenListe">
        <v-list>
          <v-list-item-group>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title @click="abschnittHinzufuegen">Neuer Abschnitt</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!--
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title @click="frageHinzufuegen">Neue Frage hinzufügen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title @click="tabelleHinzufuegen">Neue Tabelle hinzufügen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            -->
            <v-list-item :disabled="weitereVerwendung && weitereVerwendung !== ''">
              <v-list-item-content>
                <v-list-item-title @click="auswahlboxHinzufuegen">Neue Auswahlbox</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'TemplateAddNewItems',
  data() {
    return {
      zeigeItemHinzufuegenListe: false
    };
  },
  props: {
    abschnittIndex: {
      type: Number,
      default: () => 0,
    },
    weitereVerwendung: String,
  },
  methods: {
    itemHinzufuegen() {
      this.zeigeItemHinzufuegenListe = !this.zeigeItemHinzufuegenListe;
    },
    abschnittHinzufuegen() {
      this.$emit('abschnittHinzufuegen');
      this.zeigeItemHinzufuegenListe = false;
    },
    frageHinzufuegen() {
      this.$emit('frageHinzufuegen', this.abschnittIndex);
      this.zeigeItemHinzufuegenListe = false;
    },
    tabelleHinzufuegen() {
      this.$emit('tabelleHinzufuegen', this.abschnittIndex);
      this.zeigeItemHinzufuegenListe = false;
    },
    auswahlboxHinzufuegen() {
      this.$emit('auswahlboxHinzufuegen');
      this.zeigeItemHinzufuegenListe = false;
    },
  },
};
</script>
<style lang="scss" scoped>

.v-list {
  border: 1px solid #8A8A8A;
}

</style>